/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Transcript-derived MCP attribution for one model API request. Claude redacts user-configured MCP server names to 'custom' on its OTEL telemetry, but records the real names in the local session transcript; hooks ship them here so ingest can restore the redacted names.
 */
export type HookMCPAttributionEntry = {
  /**
   * Unredacted MCP server name from the transcript.
   */
  mcpServer?: string | undefined;
  /**
   * Unredacted MCP tool name from the transcript.
   */
  mcpTool?: string | undefined;
  /**
   * Provider API request identifier (e.g. Claude's req_*) the attribution applies to.
   */
  requestId: string;
};

/** @internal */
export type HookMCPAttributionEntry$Outbound = {
  mcp_server?: string | undefined;
  mcp_tool?: string | undefined;
  request_id: string;
};

/** @internal */
export const HookMCPAttributionEntry$outboundSchema: z.ZodMiniType<
  HookMCPAttributionEntry$Outbound,
  HookMCPAttributionEntry
> = z.pipe(
  z.object({
    mcpServer: z.optional(z.string()),
    mcpTool: z.optional(z.string()),
    requestId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServer: "mcp_server",
      mcpTool: "mcp_tool",
      requestId: "request_id",
    });
  }),
);

export function hookMCPAttributionEntryToJSON(
  hookMCPAttributionEntry: HookMCPAttributionEntry,
): string {
  return JSON.stringify(
    HookMCPAttributionEntry$outboundSchema.parse(hookMCPAttributionEntry),
  );
}
